import { FC } from 'react'

/* Assets */
import checked from '../../images/checked.svg'
import error from '../../images/error.svg'

/* Types */
import { DeliveryAddress } from '../../api'

type AddressesListProps = {
  addresses: DeliveryAddress[]
}

const AddressesList: FC<AddressesListProps> = (props) => {
  const { addresses } = props

  return (
    <div className={'delivery-address-list'}>
      <div className={'row delivery-address-list-title'}>
        <div className={'col-xs-10'}>Address</div>
        <div className={'col-xs-2 center'}>Claimed</div>
      </div>
      {addresses &&
        addresses.map &&
        addresses.map((each, i) => {
          return (
            <div key={each.address} className={`row delivery-address-list-row ${i % 2 === 0 ? 'even' : 'odd'}`}>
              <div className={'col-xs-10'}>
                <a href={`/scan/${each.address}`} rel="noopener noreferrer" target="_blank">
                  {each.address}
                </a>
              </div>
              <div className={'col-xs-2 center'}>
                <img
                  src={each.claimed ? checked : error}
                  alt={each.claimed ? 'Claimed' : 'Pending'}
                  className={'status-icon'}
                />
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default AddressesList
